import React from 'react'
import { styled } from 'baseui'
import type { StyleObject } from 'styletron-react'
import { lightTheme } from '@/customTheme'

type PromptInputShellProps = {
  disabled?: boolean
  active?: boolean
  hasGradientBorder?: boolean
  hasThumbnail?: boolean
  showErrorState?: boolean
  id?: string
  style?: StyleObject
  children: React.ReactNode
}

const Shell = styled('div', (props: {
  $disabled?: boolean
  $active?: boolean
  $hasGradientBorder?: boolean
  $hasThumbnail?: boolean
  $showErrorState?: boolean
  $style?: StyleObject
}) => ({
  position: 'relative',
  boxSizing: 'border-box',
  width: '100%',
  minHeight: '56px',
  padding: props.$hasThumbnail ? '8px 48px 8px 8px' : '8px 48px 8px 16px',
  display: 'flex',
  alignItems: 'center',
  background: lightTheme.colors.white,
  borderRadius: '16px',
  boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.08)',
  pointerEvents: props.$disabled ? 'none' : 'auto',
  '::before': !props.$showErrorState && props.$hasGradientBorder ? {
    content: '""',
    position: 'absolute',
    inset: '-2px',
    borderRadius: '16px',
    padding: '2px',
    background: 'linear-gradient(90deg, #02FCFF, #FC00FF)',
    WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    WebkitMaskComposite: 'xor',
    maskComposite: 'exclude',
    pointerEvents: 'none',
    opacity: props.$active ? 1 : 0,
    transition: 'opacity 0.2s ease',
    zIndex: -1,
  } : undefined,
  ':hover::before': !props.$showErrorState && props.$hasGradientBorder ? {
    opacity: props.$disabled ? 0 : 1,
  } : undefined,
  ...props.$style,
}))

const PromptInputShell = React.forwardRef<HTMLDivElement, PromptInputShellProps>(function PromptInputShell({
  disabled,
  active,
  hasGradientBorder = true,
  hasThumbnail,
  showErrorState,
  id,
  style,
  children,
}, ref) {
  return (
    <Shell
      ref={ref}
      id={id}
      $disabled={disabled}
      $active={active}
      $hasGradientBorder={hasGradientBorder}
      $hasThumbnail={hasThumbnail}
      $showErrorState={showErrorState}
      $style={style}
    >
      {children}
    </Shell>
  )
})

export default PromptInputShell
